import { render, staticRenderFns } from "./SignDocumentsStep.vue?vue&type=template&id=f5b83082&"
import script from "./SignDocumentsStep.vue?vue&type=script&lang=js&"
export * from "./SignDocumentsStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports